import Api from "@/service/api";
import { AxiosRequestConfig } from "axios";
import { CartsType } from "./interface";

// 购物车接口

/**
 * 获取购物车列表
 * @param options 
 * @returns 
 */
export async function queryShopingCartsList(options: AxiosRequestConfig) {
  return Api.request({
    url: "order/cart/list",
    method: "GET",
    params:{...options}
  });
}

/**
 * 添加商品购物车
 */
export async function addShopingCart(options: CartsType) {
  return Api.request({
    url: "order/cart/add",
    method: "POST",
    data:{...options}
  });
}

/**
 * 删除购物车商品
 */
export async function deleteShopingCart(options: {cartIdList: string[]}) {
  return Api.request({
    url: "order/cart/sku/del",
    method: "POST",
    data:{...options}
  });
}

/**
 * 计算购物车商品价格
 */
export async function calculateShopingCart(options: {cartIdList: string[]}) {
  return Api.request({
    url: "order/cart/price/cal",
    method: "POST",
    data:{...options}
  });
}

/**
 * 购物车商品数量操作接口
 */
export async function shopingCartNum(options: {cartId: string, count: number, operate: string}) {
  return Api.request({
    url: "order/cart/sku/num",
    method: "POST",
    data:{...options}
  });
}

/**
 * 购物车商品有效性校验接口
 */
export async function shopingCartValidate(options: {cartIdList: string[]}) {
  return Api.request({
    url: "order/cart/sku/valid",
    method: "POST",
    data:{...options}
  });
}

/**
 * 获取购物车商品数量
 */
export async function queryShopingCartNum() {
  return Api.request({
    url: "order/cart/overview/count",
    method: "GET",
  });
}

/**
 * 购物车勾选状态切换接口
 */
export async function toggleShopingCartSelected(options: {idList: string[], selected: boolean}) {
  return Api.request({
    url: "order/cart/sku/select",
    method: "POST",
    data:{...options}
  });
}
